module.exports = __webpack_public_path__ + "img/room_btn_yjs.8241f3a8.png";